export enum CustomFieldTypeEnum {
  TextField = 'textComponent',
  CheckboxField = 'checkboxComponent',
}
